import { render, staticRenderFns } from "./warn-num.vue?vue&type=template&id=67560922&scoped=true&"
import script from "./warn-num.vue?vue&type=script&lang=js&"
export * from "./warn-num.vue?vue&type=script&lang=js&"
import style0 from "./warn-num.vue?vue&type=style&index=0&id=67560922&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67560922",
  null
  
)

export default component.exports